import React, { useEffect, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import request from "../../../api/request";
import "./UserInfo.css";
import { BackendAPI } from "../../../const/api";
import { useToast } from "../../../component/ToastBar";

const UserInfo = () => {
  const toast = useToast();
  const [error, setError] = useState("");
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await request.get(BackendAPI.userInfo);
        if (!response.success) {
          return;
        }
        setUserInfo(response.data);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };
    fetchUserInfo().then();
  }, []);

  const handleEmailChange = (em) => {
    setUserInfo({ ...userInfo, email: em });
    if (!validateEmail(em)) {
      setError("请输入有效的邮箱地址");
    } else {
      setError("");
    }
  };

  const validateEmail = (em) => {
    return /^\w+([-+.]\w+)*@\w+([-.]\w+)*.\w+([-.]\w+)*$/.test(em);
  };

  const handlePhoneChange = (p) => {
    setUserInfo({ ...userInfo, phone: p });
    if (!validatePhone(p)) {
      setError("请输入有效的手机号");
    } else {
      setError("");
    }
  };

  const validatePhone = (p) => {
    return /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
      p,
    );
  };

  const handleSubmit = async () => {
    try {
      const res = await request.put(BackendAPI.userUpdate, userInfo);
      if (!res.success) {
        return;
      }
      // clear form
      setUserInfo({
        name: "",
        email: "",
        phone: "",
      });
      toast("用户信息更新成功");
    } catch (error) {
      console.error("Error updating user info:", error);
      setError(`用户信息更新失败: ${error}`);
    }
  };

  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleSubmit}
      className="user-info-form"
    >
      <TextField label="姓名" name="name" value={userInfo.name} disabled />
      <TextField
        label="电子邮箱"
        name="email"
        value={userInfo.email}
        onChange={(e) => handleEmailChange(e.target.value)}
      />
      <TextField
        label="电话号码"
        name="phone"
        value={userInfo.phone}
        onChange={(e) => handlePhoneChange(e.target.value)}
      />
      {error && <div className="loginError">{error}</div>}
      <Button type="submit" variant="contained">
        保存更改
      </Button>
    </Box>
  );
};

export default UserInfo;
